export default __webpack_public_path__ + "static/media/AWSGroup.bd66022e.svg";